import { useApiGet } from '../../shared/api/utils/reactQueryProvider';
import { getDriverDetails } from '../api/services/Rides';
import { DriverDetails } from '../types/driver';

interface IUseDriverDetailsQuery {
  rideSlug: string;
}

export const useDriverDetailsQuery = ({ rideSlug }: IUseDriverDetailsQuery) => {
  // driver Details endpoint can be used to return the driver qualifications when ride is unclaimed
  return useApiGet<{ data: DriverDetails }>(['driverDetails'], () => getDriverDetails(rideSlug), {
    enabled: true,
  });
};
